module.exports = __webpack_public_path__ + "img/tmp2.63a7d78d.svg";